module.exports = __webpack_public_path__ + "img/emoji_9.8fde27af.png";